export default __webpack_public_path__ + "static/social_erase_your_face-1483b5cb1acdc6ca4d4d19609a18a90f.png";